import React from 'react';
import { createRoot } from 'react-dom/client';

import Widget from './components/Widget';

function init() {
  console.log('[QUIZ-WIDGET] init');
  Array.from(document.getElementsByClassName('js-quiz')).forEach(element => {
    const widgetDataContainer = element.querySelector('script');

    if(widgetDataContainer) {
      try {
        const data = JSON.parse(widgetDataContainer.innerHTML);

        const root = createRoot(element);
        root.render(<Widget {...data} />);
      } catch(e) {
        console.error('[QUIZ-WIDGET] failed', e.message);
      }
    }
  });
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  init();
} else {
  window.addEventListener('DOMContentLoaded', init);
}
